import MovieCard from '@/components/base/MovieCard';
import { getFeaturedMovies } from '@/mocks/movies';

export default function FeaturedMovies() {
  const featured = getFeaturedMovies();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            热门<span className="text-primary-500">推荐</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精选全球影迷评分最高的欧美大片，每一部都值得你花时间观看
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featured.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>
      </div>
    </section>
  );
}